// import React ,{ useState} from 'react';


import React from "react";
import { FcCalendar } from "react-icons/fc";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
const localizer = momentLocalizer(moment);
const myEventsList = [
  { start: new Date(), end: new Date(), title: "special event" }
];

function CalendarComponent() {
  return (
    <div className="calendar_container">
      <div className="calendar_top">
        <FcCalendar />
        <h4>Calendar</h4>
      </div>
      <Calendar
        localizer={localizer}
        events={myEventsList}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
      />
    </div>
  );
}

export default React.memo(CalendarComponent);
